import { useEffect, useState } from "react";
import ListagemItem from "./ListagemItem";
import Loader from "~components/Form/components/Loader";
import InfiniteScroll from "react-infinite-scroll-component";
import { IconTop } from "~misc/icons";
import { Spinner } from "@chakra-ui/react";

const Listagem = ({
  simulacoes,
  total,
  cliente,
  anyFilters,
  desconto,
  loading,
  setSkipon,
  take = 2
}) => {
  const hasMore = !loading && simulacoes?.length < total;
  const [isLoading, setIsLoading] = useState(false);
  const loadMoreItems = () => {
    setIsLoading(true);
    if (hasMore) {
      setTimeout(() => {
      setSkipon(prev => prev + take);
      setIsLoading(false);
    }, 1100);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      <ul className="container">
        {loading && simulacoes?.length === 0 ? (
          <div className="container flex items-center justify-center pt-10">
            <Spinner size={"xl"} thickness="4px" />
          </div>
        ) : total > 0 ? (
          <>
            <InfiniteScroll
              dataLength={simulacoes?.length || 0}
              next={loadMoreItems}
              hasMore={hasMore}
              loader={isLoading && <Loader />}
            >
              {simulacoes?.map((simulacao, index) => (
                <li key={index}>
                  <ListagemItem simulacao={simulacao} desconto={desconto} cliente={cliente} />
                </li>
              ))}

              {simulacoes?.length > 0 && (
                <>

                  <button className="voltar-ao-topo" onClick={scrollToTop}>
                    <IconTop />
                  </button>
                </>
              )}
            </InfiniteScroll>
          </>
        ) : (
          <>
            {anyFilters ? (
              <p className="py-[4rem] text-center">Nenhum resultado encontrado com os filtros especificados</p>
            ) : (
              <p className="py-[4rem] text-center">Não existem simulações para esse cliente</p>
            )}
          </>
        )}
      </ul>
    </>
  );
};

export default Listagem;
